import {Box, useTheme} from '@mui/material';
import {AppTabSectionNode, AppTabSectionScroll} from 'components/tabs';
import {useTenantSettingHelper} from 'hooks/settings';
import {ReminderModel} from 'models';
import {Item_DATA_SECTION_TYPES} from 'models/board/itemData';
import {TenantSettingsKeysEnum} from 'models/settings';
import React from 'react';
import {BoardReminderList, CommentsBody, ItemDataAttachmentsTab, ItemDialogSideBarActions, ItemDrawerLogs} from '.';
import {BoardItemDetailSection, BoardItemDetailSectionProps} from '../sections';
import {ItemDataTimeTrackerHistoryTab} from './ItemDataTimeTrackerHistoryTab';

export interface BoardItemSectionRendererProps extends BoardItemDetailSectionProps {
    onRemoveItemResponseHandler: (itemId: string, closeDrawer: boolean) => void;
    openAddUpdateReminderDialog: boolean;
    setOpenAddUpdateReminderDialog: (value: boolean) => void;
    onReminderResponse?: (response: ReminderModel | undefined) => void;
    loading?: boolean;
    boardSlug: string;
}

export const BoardItemSectionRenderer: React.FC<BoardItemSectionRendererProps> = ({
    onRemoveItemResponseHandler,
    setOpenAddUpdateReminderDialog,
    openAddUpdateReminderDialog,
    onReminderResponse,
    loading,
    boardSlug,
    ...rest
}) => {
    const theme = useTheme();
    const {isSettingEnabled} = useTenantSettingHelper();
    const sections: AppTabSectionNode[] = [
        {
            sectionHeaderTitle: Item_DATA_SECTION_TYPES.DETAILS,
            key: Item_DATA_SECTION_TYPES.DETAILS.toString(),
            sectionRenderNode: <BoardItemDetailSection {...rest} loading={loading} />,
        },
        {
            sectionHeaderTitle: Item_DATA_SECTION_TYPES.ATTACHMENTS,
            key: Item_DATA_SECTION_TYPES.ATTACHMENTS.toString(),
            sectionRenderNode: <ItemDataAttachmentsTab itemData={rest.item} />,
        },

        {
            sectionHeaderTitle: Item_DATA_SECTION_TYPES.COMMENTS,
            key: Item_DATA_SECTION_TYPES.COMMENTS.toString(),
            sectionRenderNode: <CommentsBody itemData={rest.item} />,
        },
        // ...(isSettingEnabled([TenantSettingsKeysEnum.TenantEnableReminders.toString()])
        //     ? [
        //           {
        //               sectionHeaderTitle: Item_DATA_SECTION_TYPES.REMINDERS,
        //               key: Item_DATA_SECTION_TYPES.REMINDERS.toString(),
        //               sectionRenderNode: (
        //                   <BoardReminderList
        //                       onReminderResponse={onReminderResponse}
        //                       openAddUpdateReminderDialog={openAddUpdateReminderDialog}
        //                       itemDataId={rest.item.id}
        //                   />
        //               ),
        //           },
        //       ]
        //     : []),
        {
            sectionHeaderTitle: Item_DATA_SECTION_TYPES.HISTORY,
            key: Item_DATA_SECTION_TYPES.HISTORY.toString(),
            sectionRenderNode: <ItemDrawerLogs itemDataId={rest.item.id} />,
        },
        ...(isSettingEnabled([TenantSettingsKeysEnum.TenantEnableTimeTracker.toString()])
            ? [
                  {
                      sectionHeaderTitle: 'Time Tracking History',
                      key: Item_DATA_SECTION_TYPES.TIME_TRACKING.toString(),
                      sectionRenderNode: <ItemDataTimeTrackerHistoryTab itemDataId={rest.item.id} />,
                  },
              ]
            : []),
    ];

    return (
        <Box sx={{display: {xs: 'block', sm: 'flex'}}}>
            <Box
                sx={{border: `1px solid ${theme.palette.secondary.light}`, borderRadius: '10px 10px 0 0', flexGrow: 1}}
            >
                <AppTabSectionScroll
                    tabBodySectionProps={{
                        p: 1,
                        sx: {
                            overflowY: 'auto',
                            maxHeight: {
                                md: 'calc(100vh - 220px)',
                                xs: 'calc(100vh - 350px)',
                                sm: 'calc(100vh - 220px)',
                            },
                        },
                    }}
                    sections={sections}
                />
            </Box>
            <Box sx={{display: {xs: 'none', sm: 'block'}}}>
                <ItemDialogSideBarActions
                    item={rest.item}
                    itemDataId={rest.item.id}
                    onRemoveItemResponseHandler={itemId => onRemoveItemResponseHandler(itemId, true)}
                />
            </Box>
        </Box>
    );
};

export default BoardItemSectionRenderer;
